import { render, staticRenderFns } from "./ModalIntro.vue?vue&type=template&id=3e24a5c0&scoped=true&"
import script from "./ModalIntro.vue?vue&type=script&lang=js&"
export * from "./ModalIntro.vue?vue&type=script&lang=js&"
import style0 from "./ModalIntro.vue?vue&type=style&index=0&id=3e24a5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e24a5c0",
  null
  
)

export default component.exports